import React from 'react';
import PropTypes from 'prop-types';
function ClientItem(_ref) {
  var label = _ref.label,
    value = _ref.value;
  return /*#__PURE__*/React.createElement("li", {
    className: "client-item client-item--".concat(label)
  }, /*#__PURE__*/React.createElement("h3", {
    className: "client-item__label ui-h3-heavy"
  }, label, ' '), /*#__PURE__*/React.createElement("h3", {
    className: "client-item__value"
  }, value));
}
ClientItem.propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
};
export default ClientItem;
//# sourceMappingURL=ClientItem.js.map